import { IUser } from "@/settings/zustand"
import { useEffect, useState } from "react"
import { actions } from "../../data/actions"
import { GET_TEST_RESULTS_USERS_ACTION } from "../../data/actionTypes" 
import TestResultButton from "./TestResultButton"
import Feed from "src/modules/pe-basic-module/views/core/Feed"

/* Protopia Ecosystem component */ 
const TestResultsList = ( ): JSX.Element => {
    const [users, setUsers] = useState<IUser[]> ([])
    useEffect(() => { 
        actions(
            GET_TEST_RESULTS_USERS_ACTION,
            { }
        ).then((res: any[]) => {
            setUsers( res.map(r => r.user ))
        })
    },[])
    return <div className="w-100 d-flex flex-column">
        <Feed
            items={ users }
            component={ TestResultButton }
            data_type={ "" }
            containerClassName="container "
        /> 
    </div> 
}
export default TestResultsList